import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdCarouselConfigComponent } from './ngbd-carousel-config/ngbd-carousel-config.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    
    SidebarComponent,
    
    NgbdCarouselConfigComponent
  ],
  exports: [
    FooterComponent,
    
    NavbarComponent,
    SidebarComponent
  ]
})
export class ComponentsModule { }
